const ROOT_SELECTOR = '[data-experience]';
const ITEM_SELECTOR = '[data-experience-item]';
const TRIGGER_SELECTOR = '[data-experience-trigger]';

const TABS_MEDIA = '(min-width: 64em)';

const OPEN_CLASS = 'is-open';

export default function Experience() {
    const roots = Array.from(document.querySelectorAll(ROOT_SELECTOR));

    if (!roots.length) {
        return;
    }

    const tabs = window.matchMedia(TABS_MEDIA);

    roots.forEach((root) => {
        const items = Array.from(root.querySelectorAll(ITEM_SELECTOR));

        if (!items.length) {
            return;
        }

        const setOpen = (item, open) => {
            const trigger = item.querySelector(TRIGGER_SELECTOR);

            item.classList.toggle(OPEN_CLASS, open);

            if (trigger) {
                trigger.setAttribute('aria-expanded', String(open));
            }
        };

        const openOnly = (target) => items.forEach((item) => setOpen(item, item === target));

        items.forEach((item) => {
            const trigger = item.querySelector(TRIGGER_SELECTOR);

            if (!trigger) {
                return;
            }

            trigger.addEventListener('click', () => {
                const isOpen = item.classList.contains(OPEN_CLASS);

                if (isOpen && !tabs.matches) {
                    setOpen(item, false);

                    return;
                }

                openOnly(item);
            });
        });

        const onBreakpoint = () => {
            if (!tabs.matches) {
                return;
            }

            if (!items.some((item) => item.classList.contains(OPEN_CLASS))) {
                openOnly(items[0]);
            }
        };

        if (typeof tabs.addEventListener === 'function') {
            tabs.addEventListener('change', onBreakpoint);
        } else {
            tabs.addListener(onBreakpoint);
        }
    });
}
